import { createSlice } from "@reduxjs/toolkit";
import { CUSTOMER_SATISFACTON } from "../../../constants/reducer_names";
import { assign } from "lodash";
interface CustomerSatisfactionData {
  caption: string;
  ratingDesignType: number;
  labelRatingType: number;
  followUpQuestion: number;
  thanksNote: string;
  dontDisturbType: number;
  dontDistrubTime: number;
  additionalQuestions: any[];
  isVoice: number;
  callFlows: string;
  minimumDurationType: number;
  minimumDuration: string;
  isWebWidget: number;
  Widgets: string;
  isSms: number;
  smsNumbers: string;
  isSendSmsFromSameNumber: number;
  smsNumberSend: any[];
  smsMessage: string;
  isEmail: number;
  emails: string;
  isSendEmailFromSameEmail: number;
  emailIdSend: string;
  emailSubject: string;
  emailMessage: string;
  isWhatsApp: number;
  whatsAppChatFlows: string;
  isFacebook: number;
  facebookChatFlows: string;
  isInstagram: number;
  instagramChatFlows: string;
  isVideo: number;
}
const initialState ={
  activeStutas :0,
  caption:"Please rate your satisfaction with us",
    ratingDesignType:1,
   // ratingOption:1 ,
    labelRatingType:1,

    followUpQuestion:0,
    additionalQuestionType:0,
    dontDisturbType:1,
    dontDistrubTime:1,
    thanksNote:"Your feedback has been submitted.",
    additionalQuestions:[]as any,
    isVoice: 0,
    callFlows:"" as any,
    minimumDurationType:1,
    minimumDuration:1,
    isWebWidget:0,
    Widgets:"" as any,
    isSms:0,
    smsNumbers:"" as any,
    isSendSmsFromSameNumber:1,
    smsNumberSend:"" as any,
    smsMessage:"Hi [Customer Name], how was your recent experience with us? Click here to share  <Feedback question link should be provided>",
    isEmail:0,
    emails: "" as any,
    isSendEmailFromSameEmail: 1,
    emailIdSend: "" as any,
    emailSubject: "Your Feedback Matters: Help Us Improve!",
    emailMessage:`Hi Customer Name

      We hope you're enjoying [product/service]!
      
      At [Your Company Name], we're constantly striving to provide the best possible experience for our customers. Your feedback is incredibly valuable to us, and it helps us understand what we're doing well and where we can improve.
      
      Would you mind taking a few minutes to complete a short survey about your recent experience with [product/service]? It won't take longer than [estimated time] minutes.
      
      Your honest feedback will help us:
      
      Improve our products and services
      
      Better understand your needs
      
      Deliver a more enjoyable experience for you`,

      isWhatsApp:0,
      whatsAppChatFlows:"" as any,
      isFacebook:0,
      facebookChatFlows:"" as any,
      isInstagram:0,
      instagramChatFlows:"" as any,
      isVideo:0,

  };
  

    
const customersatisfactionslice :any = createSlice({
name: CUSTOMER_SATISFACTON,
  initialState,
  reducers: {
    active :(state ,{payload})=>{
      state.activeStutas = payload
    },
    formsetting: (state, { payload }) => {
      // console.log('payload123', payload)
      state.caption = payload.caption;
      state.ratingDesignType = payload.ratingDesignType;
      //state.ratingOption = payload.ratingOption;
      state.labelRatingType = payload.labelRatingType;
      state.followUpQuestion = payload.followUpQuestion ;
      state.additionalQuestionType = payload.additionalQuestionType;
      //state.questionOptiontype = payload.questionOptiontype;
      state.thanksNote = payload.thanksNote;
      state.dontDisturbType = payload.dontDisturbType;
      state.dontDistrubTime = payload.dontDistrubTime;
      state.additionalQuestions = Array.isArray(payload.additionalQuestions) ? payload.additionalQuestions : [payload.additionalQuestions];
    },

    voiceChannel: (state, { payload }) => {
      state.isVoice = payload.isVoice;
      state.callFlows = payload.callFlows;
      state.minimumDurationType = payload.minimumDurationType;
      state.minimumDuration=payload.minimumDuration;
    },
    webchatChannel: (state, { payload }) => {
      state.isWebWidget = payload.isWebWidget;
      state.Widgets = payload.Widgets;
     
    },
    smsChannel: (state, { payload }) => {
      state.isSms = payload.isSms;
      state.smsNumbers = payload.smsNumbers;
      state.isSendSmsFromSameNumber = payload.isSendSmsFromSameNumber;
      state.smsNumberSend = payload.smsNumberSend;
      state.smsMessage = payload.smsMessage;
      
    },
    emailChannel: (state, { payload }) => {
      state.isEmail = payload.isEmail;
      state.emails = payload.emails;
      state.isSendEmailFromSameEmail = payload.isSendEmailFromSameEmail;
      state.emailIdSend = payload.emailIdSend;
      state.emailSubject = payload.emailSubject;
      state.emailMessage = payload.emailMessage;

    },
    

    whatsappChannel: (state, { payload }) => {
      state.isWhatsApp = payload.isWhatsApp;
      state.whatsAppChatFlows = payload.whatsAppChatFlows;
    },

    facebookChannel: (state, { payload }) => {
      state.isFacebook = payload.isFacebook;
      state.facebookChatFlows = payload.facebookChatFlows;
    },

    instagramChannel: (state, { payload }) => {
      state.isInstagram = payload.isInstagram;
      state.instagramChatFlows = payload.instagramChatFlows;
    },

    videomeetChannel: (state, { payload }) => {
      state.isVideo = payload.isVideo;
    },
  //   reset(state) {
  //     Object.assign(state, initialState)
  // }
  reset: () => { return initialState},
  }
})
export const customerSatisfactionAction= customersatisfactionslice.actions;
export default customersatisfactionslice.reducer

